<div
  class="modal fade"
  id="deleteConfirmation"
  tabindex="-1"
  aria-labelledby="exampleModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Confirm</h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
          (click)="message.noFn()"
        >
        </button>
      </div>
      <div class="modal-body">
        {{ message?.text }}
      </div>
      <div class="modal-footer">
        <button
          type="button"
          *ngIf="!message?.isAlert"
          class="btn btn-secondary"
          data-bs-dismiss="modal"
          (click)="message.noFn()"
        >
          Close
        </button>
        <button
          type="button"
          class="btn btn-primary-sa"
          data-bs-dismiss="modal"
          (click)="message.siFn()"
        >
          Delete
        </button>
      </div>
    </div>
  </div>
</div>
